import faqsClient from '@/data/frontend/faqs/faqs-client.json';
import faqsFreelancer from '@/data/frontend/faqs/faqs-freelancer.json';
import faqsVendor from '@/data/frontend/faqs/faqs-vendor.json';
import { getSlugFromString } from '@/utils/get-slug-from-string';

type RawFAQ = {
	title: string;
	description: string;
};

type RawFAQCategory = {
	title: string;
	faqs: RawFAQ[];
};

export type FAQ = {
	title: string;
	slug?: string;
	description: string;
};

export type FAQCategory = {
	title: string;
	slug: string;
	faqs: FAQ[];
};

export type FAQsType = 'client' | 'freelancer' | 'vendor';

function getProcessedFAQsCategories(faqs: RawFAQCategory[]): FAQCategory[] {
	return faqs.map((category) => ({
		...category,
		slug: getSlugFromString(category.title),
		faqs: category.faqs.map((faq) => ({
			...faq,
			slug: getSlugFromString(faq.title),
		})),
	}));
}

export const faqsData: Record<FAQsType, FAQCategory[]> = {
	client: getProcessedFAQsCategories(faqsClient.categories),
	freelancer: getProcessedFAQsCategories(faqsFreelancer.categories),
	vendor: getProcessedFAQsCategories(faqsVendor.categories),
};
